import type { FC } from "react";
import { useResolvingNowQuery } from "web_myplann/Api/NotificationCenter/useResolvingNowQuery";
import { DashboardTimelinePreview } from "web_myplann/Dashboard/Components/DashboardTimelinePreview";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ResolvingNowItem } from "web_myplann/NotificationCenter/Components/ResolvingNowItem";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useNavigateFromResolvingNowItem } from "web_myplann/NotificationCenter/Hooks/useNavigateFromResolvingNowItem";
import { DASHBOARD_ORIGIN } from "web_myplann/NotificationCenter/Utils/notificationOrigin";

const PREVIEW_LIMIT = 2;

interface DashboardResolvingNowSectionProps {
	onEmptyChange?: (isEmpty: boolean) => void;
}

export const DashboardResolvingNowSection: FC<
	DashboardResolvingNowSectionProps
> = ({ onEmptyChange }) => {
	const { t } = useResource();
	const { data, isLoading } = useResolvingNowQuery({ limit: PREVIEW_LIMIT });
	const navigateToItem = useNavigateFromResolvingNowItem({
		origin: DASHBOARD_ORIGIN,
	});

	return (
		<DashboardTimelinePreview
			title={t(Resources.Dashboard.NotificationSections.ResolvingNow)}
			items={data?.items ?? []}
			hasMore={data?.meta.hasMore ?? false}
			isLoading={isLoading}
			showAllTab={NOTIFICATION_CENTER_TABS.Upcoming}
			ItemComponent={ResolvingNowItem}
			testId="dashboard-resolving-now"
			onItemClick={navigateToItem}
			onEmptyChange={onEmptyChange}
		/>
	);
};
